import { Field, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

@ObjectType()
@InputType('AppSettingScopeInput')
export class AppSettingScope {
  @Field(() => String)
  @Prop({ type: String })
  name: string

  @Field(() => String)
  @Prop({ type: String })
  key: string
}
